import { Link } from 'react-router-dom';
import type { AiAccess } from './useAiAccess';
import { useT } from '../i18n/i18n';

export default function CreditsBar({ access, shop = false }: { access: AiAccess | null; shop?: boolean }) {
  const t = useT();
  if (!access) return null;
  const b = access.balance;
  const metered = b.tier !== null || b.topup > 0;
  if (!metered) {
    return access.developer ? <p className="field-hint ai-credits">{t('Developer access: nothing is charged to this account.')}</p> : null;
  }
  const renews = b.periodEnd ? new Date(b.periodEnd).toLocaleDateString(undefined, { day: 'numeric', month: 'long' }) : null;
  return (
    <div className={`ai-credits${b.available <= 0 ? ' is-empty' : ''}`} role="status">
      <span><strong>{b.available}</strong> {t('credits left')}</span>
      {b.tier && b.monthlyAllowance > 0 && (
        <span className="ai-credits-meter" aria-hidden="true"><span style={{ width: `${Math.max(0, Math.min(100, Math.round((100 * b.monthlyLeft) / b.monthlyAllowance)))}%` }} /></span>
      )}
      <span className="muted">
        {b.tier
          ? (renews && b.tier !== 'TESTER'
            ? t('{left} of {allowance} this month, renews {date}', { left: b.monthlyLeft, allowance: b.monthlyAllowance, date: renews })
            : t('{left} of {allowance} this month', { left: b.monthlyLeft, allowance: b.monthlyAllowance }))
          : t('no monthly credits')}
        {b.topup > 0 ? ' · ' + t('{n} extra', { n: b.topup }) : ''}
      </span>
      {!shop && <Link to="/account/subscription#ai" className="btn secondary">{t('Get more credits')}</Link>}
      {b.available <= 0 && <span className="ai-credits-out">{t('You have used all your credits. Get more to carry on.')}</span>}
    </div>
  );
}
